<template>
  <mdb-container fluid>
    <Header></Header>
    <Admintopbar :breadcrumb="breadcrumb" />
    <section class="mt-3">
      <mdb-row>
        <mdb-col md="12">
          <checklist-creation-form @save="(checklist) => $router.push({path: `/admin/checklist/edit/${checklist.id}`})" />
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
import Header from '@/components/Header.vue';
import Admintopbar from '@/components/Admintopbar.vue';
import {
    mdbCol,
    mdbContainer,
    mdbRow,
} from 'mdbvue';
import ChecklistCreationForm from '@/components/ChecklistCreationForm.vue';

export default {
  name: 'NewChecklist',
  components: {
    Admintopbar,
    Header,
    mdbCol,
    mdbContainer,
    mdbRow,
    ChecklistCreationForm,
  },
  data() {
    return {};
  },
};
</script>
